export default __webpack_public_path__ + "static/media/storageUnit1-afterB-2048w.63c98aa4.png";